// extracted by mini-css-extract-plugin
export default {"button":"Button_button__RjcaW","button-animate":"Button_button-animate__f7+IL","button-tertiary":"Button_button-tertiary__V-1-x","primary-button":"Button_primary-button__XRXme"};